import script from "./GoEyesLandingPageHub.vue?vue&type=script&setup=true&lang=js"
export * from "./GoEyesLandingPageHub.vue?vue&type=script&setup=true&lang=js"

import "./GoEyesLandingPageHub.vue?vue&type=style&index=0&id=4902b39e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4902b39e"]])

export default __exports__